/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlayComponent from '../LoadingOverlay';
import { getCookie, getUrlParams } from '@lux/helpers';
import {
  ADDITIONAL_VERIFY_ERROR,
  authActions,
  cartActions,
  ekycActions,
  errorScenarioActions,
  eshopUserActions,
  NEW_CUSTOMER_TO_MOBILE,
  NEW_NEW_CUSTOMER,
  OTP_EXCEED_LIMIT_ERROR,
  OTP_GENERIC_ERROR,
  OTP_MISMATCH_ERROR,
  OTP_RESEND_SUCCESS,
  OTP_SENT,
  OTP_TIMEOUT_ERROR,
  OTP_VERIFIED,
  OTP_VERIFY_ERROR,
  userActions,
  WORRY_FREE_ACCOUNT_VERIFIED,
  WORRY_FREE_FA_CHECK
} from '@detox/actions';

import { Verify } from '@common-modules/registration-checkout';
import GenericError from '../ShoppingCart/GenericError';
import CPModal from '../Checkout/CPModals';

import isSimOnlyPlan from '../../helpers/is-sim-only-plan';
import { flattenNodes, getAemConfigs } from '../../helpers/common';
import {
  defaultGenericErrorModal,
  getCartError,
  getCartErrorDataModel
} from '../../helpers/cart';
import getAemComponentByName from '../../helpers/getAemComponentByName';
import CHECKOUT_CONSTANT from '../../constants/checkout';
import ORDER_CONSTANT from '../../constants/order';
import CONSTANTS from '../../constants/common';
import CONSTANT from '../../constants/common';
import useTranslate from '../../hooks/useTranslation';
import { navigate } from 'gatsby';
import ImageMsta from '../../assets/images/msta.png';
import ImageStBill from '../../assets/images/stbill.png';
import { LoginCheckoutWrapper } from './styles';
import { Modal, Spacing, Text } from '@dls/web';
import styled from 'styled-components';
import { navigation } from '../../middlewares/navigation-constants';
import useRootNavigation from '../../hooks/useRootNavigation';
import { AEM_CONFIG_KEYS, CP_ERROR_CODES } from '../../config/common';
import { CP9_FLOW } from '../../types/featureFlag.types';
import { getCreditLimitErrorProps } from '../../helpers/credit-limit';
import isFeatureFlagEnabled from '../../helpers/feature-flags';
import getIsRoiMismatch from '../../helpers/is-roi-mismatch';
import CCEMisMatchError from '../CCEPrompt/CCEMisMatchErrorModal';
import { useBrowseBackPopup } from '../../hooks/useBrowseBackPopup';
import { getUIAMLoginUrl } from '../../config';
import { getIfCISMyInfoFlow } from '../../selectors';
import SilverInfoModal from './SilverInfoModal';
import { useEkycInit } from '../../hooks/useEkycEnhancements';
import notifications from '../../config/notifications';
import { ERROR_CODES } from '../../types/common.types';
import { useLoader } from '../../hooks/useLoader';
import { AbFeatureNames } from '../../constants/ab-feature-names';
import { useABTesting } from '@wec-core/ab-testing';

const StyledImg = styled.img`
  width: 100%;
`;

export const LoginGuestCheckout = props => {
  const { t } = useTranslate();
  const { location } = props;
  const { allAemPages, allVariableConfig } = props.data;
  const variableConfigs = flattenNodes(allVariableConfig) || [];
  const [sendOtpPmxPenTestFix = 'true'] = getAemConfigs(variableConfigs, [
    AEM_CONFIG_KEYS.DETOX_SEND_OTP_PMX_PENTEST_FIX
  ]);
  const { executeRecaptcha } = useGoogleReCaptcha();

  document.title = t('LGC_DOC_TITLE');

  const siteConfigurations = getAemComponentByName(
    allAemPages,
    'SiteConfigurations'
  );
  const isWorryFreeEnabled =
    siteConfigurations && siteConfigurations.switches.DETOX_WORRY_FREE;

  const errorScenarioCtaAction = async ctaActionType => {
    if (ctaActionType === 'primary') {
      window.location.href = errorScenarioMessage?.primaryButtonLink;
    } else {
      window.location.href = errorScenarioMessage.secondaryButtonLink;
    }
  };

  const dispatch = useDispatch();
  const {
    worryFreeStatus,
    customerExists,
    isAuthLoading,
    cart,
    selectedPlan,
    placeholderValues,
    selectedProduct,
    userInformation,
    cisInformation,
    productOrder,
    verificationData,
    order,
    roiValidatedData,
    user,
    ekycState
  } = useSelector(state => {
    return {
      worryFreeStatus: state.auth?.worryFree?.status,
      customerExists: state.auth?.worryFree?.customerExists,
      isAuthLoading: state.auth?.isLoading,
      cart: state?.cart,
      selectedPlan: state?.plan,
      placeholderValues: state?.plan?.selectedPlan?.planName,
      selectedProduct: state?.product,
      userInformation: state?.user?.information,
      cisInformation: state.user?.cis?.information,
      productOrder: state?.order?.productOrder,
      verificationData: state?.checkout?.verificationData,
      order: state?.order,
      roiValidatedData: state.iphone.validateSkuData,
      userCISMyInfoAvailable: getIfCISMyInfoFlow(state),
      user: state.user,
      ekycState: state.ekyc
    };
  });
  const isSimOnlyIPP = isSimOnlyPlan(selectedPlan) && selectedProduct;
  const customerId = userInformation?.clientContext?.customers?.[0]?.customerId;
  const userMyInfo = cisInformation?.cusMyInfo;
  const isMyInfoLoading = Boolean(userMyInfo?.loading);

  const { id, passType, mobileNumber, mobileNumberWithoutFormat } =
    verificationData || {};

  const {
    sendOtp,
    verifyOtp,
    setWorryFreeStatus,
    resetWorryFreeStatus,
    additionalVerify
  } = authActions;
  const { errorScenarios } = errorScenarioActions;

  const [authStatus, setAuthStatus] = useState(
    props?.authStatus || CHECKOUT_CONSTANT.CHECKOUT_VERIFY_ID
  );
  const roiNavigateNeeded = useRef(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [customVerifyErrorMessage, setCustomVerifyErrorMessage] = useState();
  const [cceMismatch, setCceMismatch] = useState(false);
  const [checkoutGenericErrorCode, setCheckoutGenericErrorCode] = useState('');
  const [errorScenarioMessage, setErrorScenarioMessage] = useState({});
  const { allErrorMessage } = props.data;
  const allErrorMessagesFlattened = flattenNodes(allErrorMessage);
  const [
    displayingErrorScenarioMessage,
    setDisplayingErrorScenarioMessage
  ] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [verifiedToCheckout, setVerifiedToCheckout] = useState(false);
  const [showSilverInfoModal, setShowSilverInfoModal] = useState(false);
  const [
    isAdditionVerificationModalOpen,
    setIsAdditionVerificationModalOpen
  ] = useState(false);
  const { Loader } = useLoader({
    loadings: [isLoading, isAuthLoading, ekycState?.isLoading]
  });

  const {
    isFeatureAllowed: [
      abTestingEshopOtpApiEnabled,
      isWorryFreeReCaptchaEnabled,
      abTestingEshopLogoutEnabled,
      abTestDeletePendingOrderForNewFlow
    ],
    isPending: abTestingPending
  } = useABTesting({
    featureName: [
      AbFeatureNames.ESHOP_OTP_API,
      AbFeatureNames.ESHOP_RECAPTCHA,
      AbFeatureNames.ESHOP_LOGOUT,
      AbFeatureNames.DELETE_PENDING_ORDER_FOR_NEW_FLOW
    ]
  });

  const {
    renderBrowseBackModal,
    resetLoginAndCheckoutData,
    resetCheckoutError
  } = useBrowseBackPopup({
    pageName: navigation.LOGIN_GUEST_CHECKOUT,
    onConfirmBrowseBack: () => {
      window.history.back();
    },
    customPopstate: displayingErrorScenarioMessage
      ? () => {
          navigate(`/${CHECKOUT_CONSTANT.NAVIGATE_TO}`, { replace: true });
        }
      : null
  });

  const mainData = CHECKOUT_CONSTANT.MAINDATA;
  const setVerification = registrationDetails => {
    const passTypeText = mainData.PASSTYPESLIST.find(
      idType => idType.value === registrationDetails.passType
    );
    const payload = passTypeText
      ? { ...registrationDetails, passTypeText: passTypeText.text }
      : { ...registrationDetails, passTypeText: null };
    return {
      type: 'SET_VERIFICATION_ALL_DETAILS',
      payload
    };
  };

  const data = {
    id,
    passType,
    mobileNumber,
    mobileNumberWithoutFormat,
    isNewUser: verificationData?.isNewUser
  };
  useRootNavigation(cart);

  const getWorryFreeNavigation = () => {
    callEkycInit();
  };

  const checkErrorScenarios = async (addedToContact = false) => {
    try {
      await dispatch(
        errorScenarios({
          isSimOnlyIPP,
          userInformation,
          productOrder,
          isAnonymous: true,
          recalculateBlock: true,
          portIn: productOrder?.type === ORDER_CONSTANT.TYPE.PORTIN,
          addedToContact: !order.addedToContact || addedToContact,
          selectedPlan: selectedPlan?.selectedPlan,
          validateForInfomationError: true,
          shouldDeleteOpenOrder:
            productOrder?.type === ORDER_CONSTANT.TYPE.NEW &&
            abTestDeletePendingOrderForNewFlow
        })
      );
    } catch (error) {
      // To be done in the future.
    }
  };

  useEffect(() => {
    if (
      ekycState?.isInitEkycError ||
      ekycState?.initEkycpayload === ERROR_CODES.ERROR_RESPONSE
    ) {
      navigate(`/${navigation.ERROR}`, { replace: true });
    }
  }, [ekycState?.initEkycpayload, ekycState?.isInitEkycError]);

  useEffect(() => {
    if (!productOrder) {
      return navigate('/', { replace: true });
    }
  }, [productOrder]);

  useEffect(() => {
    if (
      cart?.checkoutErrorData !== null ||
      checkoutGenericErrorCode === 'CHECKOUT_GENERIC_ERROR'
    ) {
      const errorScenarioData = getCartError(
        cart?.checkoutErrorData || checkoutGenericErrorCode,
        allErrorMessagesFlattened
      );
      const cartErrorDataModel = getCartErrorDataModel(
        errorScenarioData,
        placeholderValues
      );

      const callResetLoginAndCheckoutData = async errorScenarioData => {
        if (
          errorScenarioData?.bccErrorCode === CP_ERROR_CODES.CREDIT_LIMIT_REVIEW
        )
          return;

        await resetLoginAndCheckoutData();
      };
      callResetLoginAndCheckoutData(errorScenarioData);
      setErrorScenarioMessage(cartErrorDataModel || defaultGenericErrorModal);
      setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_GENERIC_ERROR);
      setDisplayingErrorScenarioMessage(true);
    }
  }, [cart?.checkoutErrorData, checkoutGenericErrorCode]);

  useEffect(() => {
    if (
      cart?.checkoutErrorScenarioCheckCompleted === true &&
      !cart?.checkoutOrderError
    ) {
      // Redirect to the desired page.
      // Needs to get the redirect link via configuration.
      setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_OTP_VERIFIED);

      // if silver discount info present, show modal for acknowledgement
      if (cart?.checkoutInfoData) {
        setShowSilverInfoModal(true);
      } else {
        setVerifiedToCheckout(true);
      }
    }
  }, [
    cart?.checkoutErrorScenarioCheckCompleted,
    cart?.checkoutOrderError,
    cart?.checkoutInfoData
  ]);

  useEkycInit();

  const checkNeedValidateOnePassUser = () => {
    const queryParams = getUrlParams(location?.search);
    return (
      queryParams[CONSTANTS.URL_PARAMS.NEED_VALIDATE_ONE_PASS_USER] === 'true'
    );
  };
  const needValidateOnePassUser = checkNeedValidateOnePassUser();
  useEffect(() => {
    if (needValidateOnePassUser && !userInformation?.userDetails?.loginId) {
      dispatch(userActions.getUserInformation());
    }
  }, []);

  useEffect(() => {
    if (needValidateOnePassUser && userInformation?.userDetails?.loginId) {
      const isRoiMismatch = getIsRoiMismatch(
        userInformation?.userDetails?.custId,
        roiValidatedData
      );
      if (isRoiMismatch) {
        roiNavigateNeeded.current = true;
        setCceMismatch(true);
      } else {
        checkErrorScenarios();
      }
    }
  }, [userInformation]);

  useEffect(() => {
    if (
      needValidateOnePassUser &&
      userInformation?.userDetails?.loginId &&
      cart?.checkoutErrorScenarioCheckCompleted
    ) {
      if (!cart?.checkoutOrderError) {
        resetCheckoutError();

        if (cart?.checkoutInfoData) {
          setShowSilverInfoModal(true);
        } else {
          callEkycInit();
        }
      } else {
        setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_GENERIC_ERROR);
        dispatch({
          type: CHECKOUT_CONSTANT.CHECKOUT_RESET_ERROR_SCENARIO_CHECK
        });
      }
    }
  }, [
    cart?.checkoutErrorScenarioCheckCompleted,
    userInformation,
    cart?.checkoutOrderError,
    cart?.checkoutInfoData,
    isAuthLoading
  ]);

  useEffect(() => {
    setIsLoading(false);

    const statusCases = async () => {
      switch (worryFreeStatus) {
        case NEW_NEW_CUSTOMER: {
          getWorryFreeNavigation();
          break;
        }
        case OTP_SENT:
          setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_VERIFY_OTP);
          break;
        case OTP_RESEND_SUCCESS:
          setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_VERIFY_OTP);
          break;
        case WORRY_FREE_FA_CHECK:
          setErrorMessage(notifications[NEW_NEW_CUSTOMER].text);
          setCustomVerifyErrorMessage([
            t('WORRY_FREE_MISMATCH_INFO_1'),
            t('WORRY_FREE_MISMATCH_INFO_2'),
            t('WORRY_FREE_MISMATCH_INFO_3')
          ]);
          break;
        case OTP_VERIFIED:
          await checkErrorScenarios(true);
          break;
        case OTP_EXCEED_LIMIT_ERROR:
          setAuthStatus(CHECKOUT_CONSTANT.CHECKOUT_OTP_LIMIT_EXCEEDED);
          break;
        case OTP_MISMATCH_ERROR:
        case OTP_GENERIC_ERROR:
          setCheckoutGenericErrorCode('CHECKOUT_GENERIC_ERROR');
          break;
        case OTP_VERIFY_ERROR:
          setErrorMessage(t('VERIFICATION_OTP_INVALID_OTP_ERROR_MSG'));
          break;
        case OTP_TIMEOUT_ERROR:
          setErrorMessage(t('VERIFICATION_OTP_EXPIRED_OTP_ERROR_MSG'));
          break;
        case NEW_CUSTOMER_TO_MOBILE:
          // Redirect to the Additional Verification page.
          break;
        case WORRY_FREE_ACCOUNT_VERIFIED:
          setAuthStatus(CHECKOUT_CONSTANT.WORRY_FREE_ACCOUNT_VERIFIED);
          break;
        case ADDITIONAL_VERIFY_ERROR:
          setAuthStatus(CHECKOUT_CONSTANT.ADDITIONAL_VERIFY_ERROR);
          break;
        default:
          break;
      }
    };

    statusCases();
  }, [worryFreeStatus]);

  const renderGenericError = (errorScenarioMessage = {}) => {
    if (
      isFeatureFlagEnabled(CP9_FLOW) &&
      Object.values(CP_ERROR_CODES).includes(errorScenarioMessage?.errorCode)
    ) {
      const { navigateTo } = getCreditLimitErrorProps(errorScenarioMessage);
      return (
        <CPModal errorData={errorScenarioMessage} navigateTo={navigateTo} />
      );
    }

    return (
      <GenericError
        title={errorScenarioMessage.title}
        errorText={errorScenarioMessage.errorText}
        typeLinkText={errorScenarioMessage.ctaText}
        primaryButtonText={errorScenarioMessage.primaryButtonText}
        secondaryButtonText={errorScenarioMessage.secondaryButtonText}
        onPrimaryClick={() => {
          errorScenarioCtaAction('primary');
        }}
        onSecondaryClick={() => {
          errorScenarioCtaAction('secondary');
        }}
        footerList={errorScenarioMessage.footerList}
      />
    );
  };

  const callEkycInit = () => {
    const uiamAccessToken = getCookie(CONSTANT.UIAM_ACCESS_TOKEN);
    if (customerExists || (uiamAccessToken && uiamAccessToken.length > 0)) {
      dispatch({
        type: CHECKOUT_CONSTANT.SET_CHECKOUT_FLOW,
        payload: CHECKOUT_CONSTANT.CHECKOUT_EXISTING_NEW_CUSTOMER
      });
    }

    const options = {
      eKycRequired:
        selectedProduct?.selectedSimType !== 'noSIM' ||
        order?.selectedSimType !== 'noSIM',
      purposeOfVerify: 'SignUpNewService'
    };
    dispatch(ekycActions.initEkycWithEshop(options));
  };

  const onOtpSuccessClicked = () => {
    callEkycInit();
  };

  const doEmptyCart = async () => {
    if (productOrder) {
      const { productOrderId, productOrderItemId } = productOrder;

      await dispatch(
        cartActions.emptyCart({
          customerId,
          productOrderId,
          productOrderItemId
        })
      );
    }
  };

  const cceProceedClicked = async () => {
    setCceMismatch(false);

    if (roiNavigateNeeded.current) {
      await resetLoginAndCheckoutData();
      await doEmptyCart();
      navigate('/', { replace: true });
    }
  };

  const onNricVerified = async registrationDetails => {
    if (isWorryFreeReCaptchaEnabled && !executeRecaptcha) {
      return;
    }
    let recaptchaData = {};
    if (isWorryFreeReCaptchaEnabled) {
      const recaptchaToken = await executeRecaptcha('worry_free_login');
      recaptchaData = {
        captchaResponseToken: recaptchaToken,
        action: 'worry_free_login'
      };
    }
    const worryFreeParams = {
      cleanWorryFree: !registrationDetails.triggeredResend,
      mobileNumber: registrationDetails.mobileNumberWithoutFormat,
      indentType: registrationDetails.passType,
      indentValue: registrationDetails.id,
      checkBasedOnSendOtpStatus: sendOtpPmxPenTestFix === 'true',
      ...recaptchaData
    };

    const isRoiMismatch = getIsRoiMismatch(
      registrationDetails.id,
      roiValidatedData
    );
    if (isRoiMismatch) {
      setCceMismatch(true);
    } else if (!isWorryFreeEnabled) {
      dispatch(setWorryFreeStatus('NEW_NEW_CUSTOMER'));
      dispatch(setVerification(registrationDetails));
      setErrorMessage('');
      setCustomVerifyErrorMessage('');
    } else {
      setIsLoading(true);
      dispatch(setVerification(registrationDetails));
      setErrorMessage('');
      setCustomVerifyErrorMessage('');
      if (abTestingEshopLogoutEnabled) {
        await dispatch(eshopUserActions.eshopLogout({ mode: 'retainOrder' }));
      }

      dispatch(sendOtp(worryFreeParams, abTestingEshopOtpApiEnabled));
      dispatch(setWorryFreeStatus(worryFreeParams));
    }
  };

  const handleSilverInfoModalClose = async () => {
    setShowSilverInfoModal(false);
    await doEmptyCart();
    navigate('/', { replace: true });
  };

  useEffect(() => {
    if (verifiedToCheckout && !needValidateOnePassUser) {
      onOtpSuccessClicked();
    }
  }, [verifiedToCheckout, needValidateOnePassUser]);

  const renderVerification = () => {
    return (
      <>
        <LoginCheckoutWrapper>
          <Spacing top={4}>
            <Verify
              authStatus={authStatus}
              data={{
                mainData,
                data: {
                  ...data,
                  dummyMobileNumber: CONSTANTS.NEW_CUSTOMER_DUMMY_MOBILE
                }
              }}
              showNewUserSection
              errorMessage={errorMessage}
              customVerifyErrorMessage={customVerifyErrorMessage}
              isLoading={isLoading}
              configs={{
                otpTimeInterval: 30,
                onePassLoginRequired: true,
                disabledFields: [],
                ...(isWorryFreeEnabled && { showSubTitleDesc: true })
              }}
              callbacks={{
                onNricVerified,
                onOtpVerified: registrationDetails => {
                  dispatch(resetWorryFreeStatus());
                  setIsLoading(true);
                  setErrorMessage('');
                  setCustomVerifyErrorMessage('');
                  dispatch(
                    verifyOtp(
                      {
                        otpCode: registrationDetails.otp,
                        mobileNumber:
                          registrationDetails.mobileNumberWithoutFormat,
                        indentType: registrationDetails.passType,
                        indentValue: registrationDetails.id
                      },
                      abTestingEshopOtpApiEnabled
                    )
                  );
                },
                onAdditionVerificationClick: registrationDetails => {
                  setIsLoading(true);
                  setErrorMessage('');
                  setCustomVerifyErrorMessage('');
                  dispatch(
                    additionalVerify({
                      mobileNumber:
                        registrationDetails.mobileNumberWithoutFormat,
                      indentType: registrationDetails.passType,
                      indentValue: registrationDetails.id,
                      lob: 'MOB',
                      billingAccountNumber: registrationDetails.accountNumber
                    })
                  );
                },
                onOnePassLoginClick: async () => {
                  if (abTestingEshopLogoutEnabled) {
                    await dispatch(
                      eshopUserActions.eshopLogout({ mode: 'retainOrder' })
                    );
                  }

                  // Just to make sure that eshop clear token cookie before navigating
                  setTimeout(() => {
                    window.open(
                      getUIAMLoginUrl(
                        `${navigation.LOGIN_GUEST_CHECKOUT}?${CONSTANTS.URL_PARAMS.NEED_VALIDATE_ONE_PASS_USER}=true`
                      ),
                      '_self'
                    );
                  }, 600);
                },
                onAdditionalVerificationModalClick: () => {
                  setIsAdditionVerificationModalOpen(true);
                }
              }}
              localisation={
                isWorryFreeEnabled
                  ? {
                      VERIFICATION_TITLE: t('LOGIN_WITH_OTP'),
                      VERIFICATION_SUBTITLE: t('VERIFICATION_SUBTITLE'),
                      VERIFICATION_NEW_USER_SUBTITLE: t(
                        'VERIFICATION_NEW_USER_SUBTITLE'
                      ),
                      VERIFICATION_NEW_USER_NEXT_BUTTON: t(
                        'VERIFICATION_NEW_USER_NEXT_BUTTON'
                      ),
                      VERIFICATION_GET_SMS_OTP: t('VERIFICATION_GET_SMS_OTP'),
                      VERIFICATION_REQUIREMENTS: t('VERIFICATION_REQUIREMENTS'),
                      VERIFICATION_OTP_VERIFY_WITH_ONEPASS_TEXT: null,
                      VERIFICATION_OTP_VERIFY_WITH_ONEPASS: t(
                        'VERIFICATION_OTP_VERIFY_WITH_ONEPASS'
                      ),
                      VERIFICATION_MOBILE_NUMBER_LABEL: t(
                        'VERIFICATION_MOBILE_NUMBER_LABEL'
                      )
                    }
                  : {
                      VERIFICATION_TITLE: 'Register your details',
                      VERIFICATION_SUBTITLE:
                        'Enter your current contact number.',
                      VERIFICATION_GET_SMS_OTP: 'Enter personal details',
                      VERIFICATION_REQUIREMENTS: null,
                      VERIFICATION_OTP_VERIFY_WITH_ONEPASS_TEXT:
                        'Existing Singtel customer? ',
                      VERIFICATION_OTP_VERIFY_WITH_ONEPASS:
                        'Log in with OnePass or Singpass'
                    }
              }
            />
          </Spacing>

          {showSilverInfoModal ? (
            <SilverInfoModal
              isModalOpen={showSilverInfoModal}
              onClose={handleSilverInfoModalClose}
              onCtaClick={() => {
                setShowSilverInfoModal(false);
                onOtpSuccessClicked();
              }}
            />
          ) : null}

          <Modal
            data-testid="howDoIFindModal"
            visible={isAdditionVerificationModalOpen}
            title={t('ADDITIONAL_VERIFICATION_WHERE_TO_FIND')}
            onClose={() => setIsAdditionVerificationModalOpen(false)}
          >
            <Modal.Content>
              <Spacing bottom={2}>
                <Text type="body">
                  {t('ADDITIONAL_VERIFICATION_WHERE_TO_FIND_DESCRIPTION')}
                </Text>
              </Spacing>
              <Spacing bottom={1}>
                <StyledImg src={ImageStBill} alt="Image of Singtel Bill" />
              </Spacing>
              <StyledImg src={ImageMsta} alt="Image of My Singtel App" />
            </Modal.Content>
          </Modal>
        </LoginCheckoutWrapper>
        {cceMismatch && (
          <CCEMisMatchError
            proceedClicked={cceProceedClicked}
            isLoggedInUser={roiNavigateNeeded.current}
          />
        )}
        {(isAuthLoading || cart.loading || isMyInfoLoading) && (
          <LoadingOverlayComponent />
        )}
        {renderBrowseBackModal()}
        <Loader />
      </>
    );
  };

  switch (authStatus) {
    case CHECKOUT_CONSTANT.CHECKOUT_GENERIC_ERROR:
      return renderGenericError(errorScenarioMessage);

    default:
      return renderVerification();
  }
};

export default LoginGuestCheckout;
